import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { ClockIcon, Cog6ToothIcon, PlusIcon } from '@heroicons/react/24/outline'
import ChatComposer from './ChatComposer'
import ChatTabs from './ChatTabs'
import MessageList from './MessageList'
import PermissionsPanel from './PermissionsPanel'
import ThreadList from './ThreadList'
import { useChat } from '../../providers/chat/context'

const ICON_BUTTON =
  'flex size-8 shrink-0 items-center justify-center rounded-md text-stone-500 transition hover:bg-stone-200 hover:text-purple-700'
const PANEL =
  'z-30 max-w-[calc(100vw-1.5rem)] overflow-y-auto rounded-lg border border-stone-200 bg-white shadow-lg [--anchor-gap:6px] [--anchor-max-height:60vh]'

export default function ConversationView({ embedded = false }: { embedded?: boolean }) {
  const { activeId, balance, newThread, threads } = useChat()
  const title = threads.find(({ id }) => id === activeId)?.title

  return (
    <div className="flex min-h-0 flex-1 flex-col max-md:h-[calc(100dvh-3rem)]">
      <div className="flex shrink-0 items-center gap-3 border-b border-stone-200 px-3 pt-2">
        <div className="min-w-0 flex-1">
          {embedded ? (
            <p className="truncate pb-2 text-sm font-medium text-stone-900">{title || 'Chat'}</p>
          ) : (
            <ChatTabs />
          )}
        </div>

        {!embedded && (
          <button type="button" aria-label="New chat" onClick={newThread} className={ICON_BUTTON}>
            <PlusIcon className="size-4.5" />
          </button>
        )}

        <div className="flex shrink-0 items-center gap-1">
          {balance && (
            <span
              title={`${balance.credits_used} of ${balance.credits_total} ad credits used`}
              className="hidden text-xs whitespace-nowrap text-stone-400 sm:inline"
            >
              {balance.credits_used} / {balance.credits_total} credits used
            </span>
          )}

          {!embedded && (
          <Popover className="relative">
            <PopoverButton aria-label="Past conversations" className={ICON_BUTTON}>
              <ClockIcon className="size-4.5" />
            </PopoverButton>
            <PopoverPanel anchor="bottom end" className={`${PANEL} w-72`}>
              <p className="px-3 pt-3 pb-1 text-[11px] font-semibold tracking-wide text-stone-500 uppercase">
                Past conversations
              </p>
              <ThreadList />
            </PopoverPanel>
          </Popover>
          )}

          <Popover className="relative">
            <PopoverButton aria-label="Settings" className={ICON_BUTTON}>
              <Cog6ToothIcon className="size-4.5" />
            </PopoverButton>
            <PopoverPanel anchor="bottom end" className={`${PANEL} w-80`}>
              <PermissionsPanel />
            </PopoverPanel>
          </Popover>
        </div>
      </div>

      <MessageList />
      <ChatComposer />
    </div>
  )
}
